export enum ContestActionType {
  COMMUNICATION_CONFIRM = 'COMMUNICATION_CONFIRM',
  COMMUNICATION_OPENING = 'COMMUNICATION_OPENING',
  LOGIN = 'LOGIN',
  USER_PHOTO_ENTRY = 'USER_PHOTO_ENTRY',
  SURVEY_SUBMITTED = 'SURVEY_SUBMITTED',
}
